import { Box, Typography, useTheme } from "@material-ui/core";
import { useEffect, useMemo, useState } from "react";
import RadarChart from "src/components/ScoringChart/RadarChart";
import InfoIcon from "src/components/Icon/InfoIcon";
import { THEME_MODE } from "src/config/constants";
import { COLOR_ARRAY_TRANS } from "src/config/styleConfig";
import { useTokenAnalysisSelector } from "src/context/tokenAnalysisContext";
import { HealthTooltip } from "./HealthTooltip";

const getOption = (theme) => ({
  chart: {
    height: 400,
  },
  colors: COLOR_ARRAY_TRANS,
  pane: {
    startAngle: 0,
    endAngle: 360,
  },
  xAxis: {
    labels: {
      formatter: function () {
        return `
        <div style="padding:0.25rem;background-color:${
          theme.palette.type === THEME_MODE.DARK ? "#07111C" : "#F2F4F7"
        };border-radius:1px;">
          <div style="font-size:10px;color:${theme.palette.text.hint};">${this.value}</div>
        </div>`;
      },
      useHTML: true,
    },
  },
  yAxis: {
    angle: -30,
    showLastLabel: true,
    labels: {
      formatter: function () {
        return `<span style='font-size:14px;font-weight:500;'> ${this.value} </span>`;
      },
      useHTML: true,
    },
  },
  plotOptions: {
    bar: {
      dataLabels: {
        enabled: true,
        style: {
          fontSize: 13,
        },
      },
      borderWidth: 0,
      borderRadius: 2,
      colorByPoint: true,
    },
    series: {
      pointWidth: 20,
    },
  },
  legend: {
    enabled: true,
  },
  tooltip: {
    enabled: true,
    shared: true,
  },
});

const TokenComparisonHealthChart = ({ tokenIds }) => {
  const theme = useTheme();
  const tokens = useTokenAnalysisSelector((state) => state.tokens);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 0.0001);
  }, [tokens, tokenIds]);

  const { series } = useMemo(() => {
    if (tokens && !loading) {
      return {
        series: tokens
          .filter((element) => tokenIds.includes(element.token_id))
          .map((element) => {
            return {
              type: "area",
              pointPlacement: "on",
              name: element.name,
              data: [
                element.credit_score,
                element.market_cap_score,
                element.trading_over_cap_score,
                element.price_over_highest_score,
                element.price_stability_score,
                element.number_of_transaction_score,
                element.holders_score,
                element.holder_distribution_score,
              ],
            };
          }),
      };
    }
    return {
      series: [],
    };
  }, [tokens, tokenIds, loading]);

  return (
    <>
      <Box pb={2} display="flex" justifyContent="flex-start">
        <Typography variant="h4">Token Health</Typography>
        <InfoIcon title={<HealthTooltip />} maxWidth="1000px" placement="bottom" />
      </Box>
      {series && (
        <RadarChart
          categories={[
            "Health Score",
            "Market Cap Score",
            "Volume Score",
            "Price Score",
            "Price Stability Score",
            "Daily Tx Score",
            "Holders Score",
            "Holder Distribution Score",
          ]}
          series={series}
          option={getOption(theme)}
          isLoading={loading}
        />
      )}
    </>
  );
};

export default TokenComparisonHealthChart;
